import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminCatalogosSatPage } from "@/features/admin-catalogos-sat/components/AdminCatalogosSatPage";
import { clavesSatAdminQueryOptions } from "@/features/admin-catalogos-sat/hooks/use-claves-sat-admin";

/** Ruta `/admin/catalogos-sat` · CRUD del catálogo SAT. */
export const Route = createFileRoute("/_authed-tw/admin/catalogos-sat")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminCatalogosSat])
      ? queryClient.ensureQueryData(clavesSatAdminQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminCatalogosSat]}>
      <AdminCatalogosSatPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
